import api from 'services/api'
import {
  GET_ADS_LIST,
  DELETE_AD,
  CREATE_AD,
  UPDATE_AD,
  GET_AD_DETAIL,
  ADD_AD_IMAGE,
  DELETE_AD_IMAGE,
  Get_AD_Categoires,
} from '../endpoints'

export const getAdsList = async (body) => await api.post(GET_ADS_LIST, body)
export const getCategories = async () => await api.get(Get_AD_Categoires)
export const deleteAd = async (id) => await api.delete(DELETE_AD, {data: {ad_id: id}})
export const getAdDetail = async (id) => await api.get(`${GET_AD_DETAIL}?ad_id=${id}`)
export const removeAdImage = async (id) => await api.delete(DELETE_AD_IMAGE, {data: {id}})

export const submitAd = async (values, id) =>
  await api.post(id ? UPDATE_AD : CREATE_AD, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

export const addAdImages = async (id, values) =>
  await api.post(`${ADD_AD_IMAGE}?ad_id=${id}`, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
